import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';

import {HttpClient} from "@angular/common/http";
import {ConfigService} from "../../config.service";
import {Configuration} from "../../models/configuration.model";
import  packageJson from '../../../../package.json';

@Injectable()
export class AppInfosService {

  private config: Configuration;

  constructor(private http: HttpClient,
              private configService: ConfigService) {
    this.config = this.configService.getConfiguration();
  }


  getAppVersion(): Observable<any> {
    return this.http.get(this.config.backendUrl + '/appInfos/allInformations')
  }

  getFrontVersion(): string {
    return packageJson.version;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/data/app-infos.service.ts